module.exports = __webpack_public_path__ + "img/vallone-exalt-tooltips-configurator-05.8df56e9b.jpg";